import React from "react";
import { useNavigate } from "react-router-dom";

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaCopy,
  FaPenAlt,
  FaPen,
} from "react-icons/fa";

const user = {
  name: "Debbie W. Johns",
  title: "Title",
  mobile: "+234 900 111 2222",
  email: "debbiewjohns@gmail.com",
  location: "Lagos, Nigeria",
  social: {
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    instagram: "https://instagram.com",
  },
  profileImage: "https://via.placeholder.com/150",
};

export default function ProfilePage() {
  const navigate = useNavigate();

  function handleEditProfile() {
    navigate("/profile/editProfile");
  }

  return (
    <div className="min-h-screen bg-white p-6">
      <Header />
      <UserProfile onNavigate={handleEditProfile} />
    </div>
  );
}

function Header() {
  return (
    <h2 className="text-purple-600 font-satoshi text-20 font-bold">
      My Profile
    </h2>
  );
}

function UserProfile({ onNavigate }) {
  const profileStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
  };
  return (
    <div className="mt-10">
      <div>
        <img src="/assets/bg-picture.png" className="w-full" alt="Background" />
      </div>
      <div
        className="w-[1000px] mx-auto p-3 rounded-lg shadow-lg flex justify-between items-center relative z-20 bottom-16"
        style={profileStyle}
      >
        <PictureProfile />
        <Button />
      </div>
      <PersonalInformation onNavigate={onNavigate} />
    </div>
  );
}

function PictureProfile() {
  return (
    <div className="flex items-center gap-3">
      <img
        src="../assets/bruce-mars.png"
        className="rounded-md"
        alt="Profile"
      />
      <div className="font-Nunito">
        <h4 className="text-24 font-bold text-[#141414]">Debbie W. Johns</h4>
        <p className="text-14 text-[#8C8C8C]">Title</p>
      </div>
    </div>
  );
}

function Button() {
  return (
    <button className="flex items-center gap-2 bg-white shadow-sm text-[#67748E] px-3 py-2 rounded-md font-Nunito text-[14px]">
      <FaCopy size={15} />
      <span>Overview</span>
    </button>
  );
}

function PersonalInformation({ onNavigate }) {
  return (
    <div className="p-6 bg-white rounded-lg shadow-sm mt-6">
      <div className="flex justify-between items-center">
        <h2 className="font-OpenSans font-medium text-16 text-[#252F40]">
          Personal Information
        </h2>
        <FaPen className="text-purple cursor-pointer" onClick={onNavigate} />
      </div>

      <p className="w-[807px] font-Nunito text-14 text-[#67748E] mt-4 mb-6">
        Lorem ipsum dolor sit amet consectetur. Tincidunt malesuada hendrerit
        eget a elementum arcu posuere. Condimentum nam ipsum bibendum sem
        commodo elementum non sit. Sapien eget justo sapien nullam arcu. Diam
        scelerisque egestas viverra sed blandit.
      </p>
      <UserDetails />
    </div>
  );
}

function UserDetails() {
  return (
    <div className="grid grid-cols-1 gap-3">
      <DetailItem label="Full Name" value={user.name} />
      <DetailItem label="Mobile" value={user.mobile} />
      <DetailItem label="Email" value={user.email} />
      <DetailItem label="Location" value={user.location} />
      <SocialLinks />
    </div>
  );
}

function DetailItem({ label, value }) {
  return (
    <div className="flex items-center gap-10 font-medium">
      <h4 className=" font-OpenSans text-[#67748E] text-14">{label}:</h4>
      <p className="text-gray-700 font-OpenSans text-14">{value}</p>
    </div>
  );
}

function SocialLinks() {
  return (
    <div className="flex items-center gap-10">
      <h4 className="font-medium text-[rgb(103,116,142)] text-14">Social:</h4>
      <div className="flex space-x-4 ">
        <a
          href={user.social.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#344E86]"
        >
          <FaFacebookF />
        </a>
        <a
          href={user.social.twitter}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#3EA1EC]"
        >
          <FaTwitter />
        </a>
        <a
          href={user.social.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#E1306C]"
        >
          <FaInstagram />
        </a>
      </div>
    </div>
  );
}
